import laptopSvg from '@plone/volto/icons/laptop.svg';
import Edit from './Edit';
import View from './View';

export const iframeBlock = {
  id: 'junts_iframe',
  title: 'Iframe',
  icon: laptopSvg,
  group: 'common',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  blockHasOwnFocusManagement: true,
};
